module.exports = __webpack_public_path__ + "static/media/dressing1.ad6e01c3.jpg";